import React, { useEffect, useState } from 'react';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';
import { SidebarItem } from '@backstage/core-components';
import LightIcon from '@material-ui/icons/WbSunny';
import DarkIcon from '@material-ui/icons/Brightness2';
import { DARK_THEME_ID, LIGHT_THEME_ID } from '../../theme/themeIds';

/**
 * A one-click Light/Dark toggle for the sidebar, sitting beside Settings.
 *
 * Reflects the currently active theme (falling back to the OS preference when
 * the user is on "Auto") and flips to the opposite mode on click. The choice
 * is persisted by Backstage's AppThemeApi, so it survives reloads.
 */
export const SidebarThemeToggle = () => {
  const appThemeApi = useApi(appThemeApiRef);
  const [themeId, setThemeId] = useState(appThemeApi.getActiveThemeId());

  useEffect(() => {
    const subscription = appThemeApi
      .activeThemeId$()
      .subscribe(id => setThemeId(id));
    return () => subscription.unsubscribe();
  }, [appThemeApi]);

  const prefersDark =
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
      : false;

  // Explicit choice wins; otherwise follow the OS.
  const isDark = themeId ? themeId === DARK_THEME_ID : prefersDark;

  return (
    <SidebarItem
      icon={isDark ? LightIcon : DarkIcon}
      text={isDark ? 'Light mode' : 'Dark mode'}
      onClick={() =>
        appThemeApi.setActiveThemeId(isDark ? LIGHT_THEME_ID : DARK_THEME_ID)
      }
    />
  );
};
